export const LOAD_MORE_SET_PRODUCTS = 'LOAD_MORE_SET_PRODUCTS';
export const SET_TOTAL_PRODUCTS_COUNT = 'SET_TOTAL_PRODUCTS_COUNT';
export const PRODUCTS_RECEIVE_PRODUCTS_WRAPPER =
  'PRODUCTS_RECEIVE_PRODUCTS_WRAPPER';

export const setCurrentProductsCount = (currentProductCount) => ({
  type: LOAD_MORE_SET_PRODUCTS,
  payload: {
    currentProductCount,
  },
});

export const receiveProductsWrapper = (productsWrapper) => {
  return {
    type: PRODUCTS_RECEIVE_PRODUCTS_WRAPPER,
    payload: {
      productsWrapper,
    },
  };
};

export const setTotalProducts = (totalProducts) => ({
  type: SET_TOTAL_PRODUCTS_COUNT,
  payload: {
    totalProducts,
  },
});
